import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { ceilMeasure, getDateInUserTimezone, headerHeight, useViewModel, zIndexCurrentTimeLine } from '@utils';
import { CalendarViewModel, ProfileViewModel } from '@views';
import '../../styles/components/currentTimeLine.scss';

interface CurrentLineProps {
  marginTop?: number;
}

/** Линия, показывающая текущее время. Используется в DayCalendar, WeekCalendar */
export const CurrentTimeLine: FC<CurrentLineProps> = observer(({ marginTop }) => {
  const calendarViewModel = useViewModel(CalendarViewModel);
  const profileViewModel = useViewModel(ProfileViewModel);
  const [date, setDate] = useState(getDateInUserTimezone(new Date().toString(), profileViewModel.minutesOffset));
  const [isDisplayed, setDisplayed] = useState(!profileViewModel.isLoading && profileViewModel.initPromise !== null);
  useEffect(
    () => setDisplayed(!profileViewModel.isLoading && profileViewModel.initPromise !== null), 
    [profileViewModel.isLoading, profileViewModel.initPromise !== null]
  );

  const getTop = () => (
   (((date.getMinutes() + date.getHours() * 60 / ceilMeasure) + headerHeight) - (calendarViewModel.startHour * 60 / ceilMeasure))
  );

  const [top, setTop] = useState(getTop());

  useEffect(() => {
    setDate(getDateInUserTimezone(new Date().toString(), profileViewModel.minutesOffset));
  }, [profileViewModel.minutesOffset]);

  useEffect(() => {
    const timer = setInterval(() => {
      setDate(getDateInUserTimezone(new Date().toString(), profileViewModel.minutesOffset));
      setTop(getTop());
    }, 300000);
    return () => clearInterval(timer);
  }, [date, top]);

  useEffect(() => {
    setTop(getTop());
  }, [calendarViewModel.startHour, date]);

  return (
    <div
      className='current-time-line'
      style={{ top, marginTop, zIndex: zIndexCurrentTimeLine, visibility: isDisplayed ? 'visible' : 'hidden' }}
    />
  );
});
